import React from "react";

export default function Pagination({
  currentPage,
  onDataCountChange,
  totalItems,
  rowLimit,
  handlePrevPage,
  handleNextPage,
}) {
  // Calculate total pages based on totalItems and rowLimit
  const totalPages = Math.ceil(totalItems / rowLimit);
  return (
    <div className="d-flex justify-content-end align-items-center gap-3 ">
      <div className="pagination_navbar">
        <div className="pagination-button-wrapper">
          <span className="row-title">Rows per page:</span>
          <label className="row-label">
            <select
              value={rowLimit}
              onChange={onDataCountChange} // Reset to page 1 when row limit changes
              className="form-select bg-transparent"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={30}>30</option>
            </select>
          </label>
          {/* Pagination info */}
          <span className="pagination-info">
            {(currentPage - 1) * rowLimit + 1} -{" "}
            {Math.min(currentPage * rowLimit, totalItems)} of {totalItems}
          </span>
          {/* Previous Page Button */}
          <button
            className="pagination-button"
            onClick={() => handlePrevPage(currentPage)}
            disabled={currentPage === 1}
          >
            <i className="fa-solid fa-chevron-left"></i>
          </button>
          {/* Current page info */}
          <span className="pagination-page-info">{currentPage}</span>
          {/* Next Page Button */}
          <button
            className="pagination-button"
            onClick={() => handleNextPage(currentPage)}
            disabled={currentPage === totalPages}
          >
            <i className="fa-solid fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
